import Vue from 'vue'
import Vuex from 'vuex'
import staticData from '@api/staticData'

import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

const store = new Vuex.Store({
    plugins: [createPersistedState()],
    state: {
        modalNaoPermitido: false,
        isLogged: false,
        isAdmin: false,
        empresa: null,
        user: null,
    },
    getters: {

    },
    mutations : {
        isLogged(state, payload){
            state.isLogged = payload
        },
        setUser(state, payload){
            state.user = payload

            if(payload.admin){
                state.isAdmin = true
            }
        },
        setEmpresa(state, payload){
            state.empresa = payload
        },
    },
    actions: {

    },
})

export default store
